export const zoneOf = (num) => {
  const n = parseInt(num, 10);
  if (n <= 10) return "central";
  if (n <= 20) return "middle";
  if (n <= 30) return "south";
  return "new";
};

export const ZONES = {
  central: { fill: "#E5A93C", text: "#0A0D14", border: "#0A0D14" },
  middle: { fill: "#F2D9A0", text: "#0A0D14", border: "#0A0D14" },
  south: { fill: "#9A5B26", text: "#F7EBD3", border: "#0A0D14" },
  new: { fill: "#141925", text: "#E5A93C", border: "#E5A93C" },
};

export const LANDMARKS = [
  { key: "port", icon: "anchor", lat: 43.60262, lng: 51.22071 },
  { key: "airport", icon: "plane", lat: 43.8601, lng: 51.092 },
  { key: "boulevard", icon: "trees", lat: 43.64538, lng: 51.15375 },
  { key: "theatre", icon: "drama", lat: 43.64773, lng: 51.15811 },
  { key: "lighthouse", icon: "lighthouse", lat: 43.63636, lng: 51.16163 },
];

export const CITY_VIEW = { center: [43.662, 51.162], zoom: 13 };

export const diameterKm = (radiusM) => ((radiusM * 2) / 1000).toLocaleString("ru-RU", { maximumFractionDigits: 2 });
